import { render, staticRenderFns } from "./JobsList.vue?vue&type=template&id=57a5ce2f&scoped=true&"
import script from "./JobsList.vue?vue&type=script&setup=true&lang=js&"
export * from "./JobsList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./JobsList.vue?vue&type=style&index=0&id=57a5ce2f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a5ce2f",
  null
  
)

export default component.exports